import firebaseConfig from '../../../firebaseConfig/firebase'
import { initializeApp } from 'firebase/app'

const app = initializeApp(firebaseConfig)

export default app
